module.exports = __webpack_public_path__ + "assets/img/tg.8ff1e53a.png";